import React, { useEffect } from 'react';

const Home = () => {
  useEffect(() => {
    console.log('Home component mounted');
  }, []);

  return (
    <div className="home-container">
      <h1>Find out who's behind the scam</h1>
      <p>Stay vigilant, crime season is here.</p>
      <div className="featured-posts">
        <h2>Featured Posts</h2>
        <p>Loading posts...</p>
      </div>
    </div>
  );
};

export default Home; 